<main role="main" id="content" class="pale-grey-bg subscribed-user">

  <!-- our banner and title -->
  <section class="subscribed-top-banner">
      <div class="state-ribbon subscribed">
        <div class="ribbon-block"></div>
        <p class="title-emulator">Subscribed</p>
      </div>
      <h1>Welcome to AmiLearn</h1>
  </section>

  <section class="card-container pull-it-up" role="navigation">
    <div class="three-cards">
      <ng-container *ngFor="let card of cards">
        <ng-template #infocard>
          <app-information-card
            style="display: contents"
            [title]="card.title"
            [description]="card.description"
            [a11yImages]="card.a11yImages"
          >
            <img
              [src]="card.image.url"
              [attr.alt]="card.image.alt || null"
              [width]="card.image.width || null"
              [title]="card.image.title || null"
            >
          </app-information-card>
        </ng-template>
        <a *ngIf="card.external; else internal" [href]="card.linkTo" [target]="(card.target) || '_self'" class="ami-card large-card" role="link">
          <ng-container *ngTemplateOutlet="infocard"></ng-container>
        </a>
        <ng-template #internal>
          <a [routerLink]="currentRoute" queryParamsHandling="preserve" [fragment]="card.linkTo" class="ami-card large-card internal" role="link">
            <ng-container *ngTemplateOutlet="infocard"></ng-container>
          </a>
        </ng-template>
      </ng-container>
    </div>
  </section>

  <!-- new section for subscribed user. entirely possible this will all change -->
  <section class="digital-asset-advisor">
    <div class="simple-banner">
        <h2>Become a <br>Certified Digital Asset Advisor.</h2>
    </div>

    <article>
      <div class="grid-half-left">
          <p>
            In addition to your AmiLearn subscription, you can add the certification bundle, created by Advisors for Advisors. Receive a certification in Digital Asset, so you can help your clients now, and in the future.
          </p>
          <p>
            We support and host a 12-hour Digital Asset Professional Accreditation, which is certified by outside industry experts.
          </p>
      </div>
      <div class="grid-half-right">
        <p>
            If, as an individual or enterprise, Digital Asset certification is on your learning path, consider yourself covered by AmiLearn.
          </p>
          <div class="button-box--paragraph">
            <a href="mailto:info@amilearn.ca" class="btn btn-secondary">
              Contact us to learn more
            </a>
          </div>
      </div>
          
    </article>
  </section>

  <section class="industry-perspectives" id="industry-perspectives">
    <article class="section-intro--simple">
      <div class="btn-icon icon__ami-default">
        <picture>
          <source type="image/webp" srcset="/assets/imgs/icons/Industry-perspective_icon_People.webp">
          <source type="image/png" srcset="/assets/imgs/icons/Industry-perspective_icon_People.png">
          <img type="image/png" src="/assets/imgs/icons/Industry-perspective_icon_People.png" width="27" alt="" title="Expand your connections" aria-hidden="true">
        </picture>
      </div>
      <h2>Industry Perspectives</h2>
      <p>Thought leaders in the Wealth Management space share their insights and perspectives on Digital Assets.</p>
    </article>

    <article class="card-container">
      <div class="three-cards">
        <div class="ami-card slim-card">
            <iframe class="video" src="https://player.vimeo.com/video/814366643?h=c0461bc599&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Industry Perspectives &amp;ndash; Interview with Adam Blumberg"></iframe>
            <p class="slim-card--paragraph">An Advisor Educator Perspective on Digital Assets (with Adam Blumberg)</p>
        </div>

        <div class="ami-card slim-card">
            <iframe class="video" src="https://player.vimeo.com/video/814383609?h=41f3da14c8&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Industry Perspectives &amp;ndash; Interview with Mike Cavanaugh"></iframe>
            <p class="slim-card--paragraph">A Broker Dealer Perspective on Digital Assets (with Mike Cavanaugh)</p>
        </div>

        <div class="ami-card slim-card">
            <iframe class="video" src="https://player.vimeo.com/video/822103358?h=3078bbe890&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="A Custody Provider Perspective with Tetra Trust"></iframe>
            <p class="slim-card--paragraph">A Custody Provider Perspective on Digital Assets (with Didier Lavallée)</p>
        </div>
      </div>
    </article>
  </section>

  <section class="stories-from-the-street" id="stories-from-the-street">
    <article class="section-intro--simple">
      <div class="btn-icon icon__ami-default">
        <picture>
          <source type="image/webp" srcset="/assets/imgs/icons/Stories-section_icon_Globe.webp">
          <source type="image/png" srcset="/assets/imgs/icons/Stories-section_icon_Globe.png">
          <img type="image/png" src="/assets/imgs/icons/Stories-section_icon_Globe.png" width="27" alt="" title="Stories From the Street" aria-hidden="true">
        </picture>
      </div>
      <h2>Stories From the Street</h2>
      <p>Real-world scenarios that Advisors experience in their daily practice. </p>
    </article>

    <article class="card-container">
      <div class="four-cards">

        <a href="/assets/pdfs/stories-from-the-street/Stories_Client-wants-bitcoin_040323-1.pdf" class="ami-card small-card" target="_blank">
          <span class="sr-text">This link opens 'Jim's Client Wants Bitcoin' PDF in a new tab</span>
          <picture>
            <source type="image/webp" srcset="/assets/imgs/street-stories/stories-Jim's-Client-wants-Bitcoin-2x.webp">
            <source type="image/png" srcset="/assets/imgs/street-stories/stories-Jim's-Client-wants-Bitcoin-2x.png">
            <img type="image/png" src="/assets/imgs/street-stories/stories-Jim's-Client-wants-Bitcoin-2x.png" alt="A hand-drawn white yacht pulls up to a blue lake's dock on a sunny day, where bitcoin waits for them." title="Jim's client needs help with bitcoin">
          </picture>
          <h3 class="small-card--title">Jim's client wants bitcoin.</h3>
          <p class="small-card--paragraph">A client has contacted Jim to discuss the possibility of allocating a small portion of cash to bitcoin.
          </p>
        </a>

        <a href="/assets/pdfs/stories-from-the-street/Stories_Client-needs-digital-asset-custody_040323-1.pdf" class="ami-card small-card" target="_blank">
          <span class="sr-text">This link opens 'Michelle's Client Needs Help' PDF in a new tab</span>
          <picture>
            <source type="image/webp" srcset="/assets/imgs/street-stories/Stories-Michelles-Client-Custody-2x.webp">
            <source type="image/png" srcset="/assets/imgs/street-stories/Stories-Michelles-Client-Custody-2x.png">
            <img type="image/png" src="/assets/imgs/street-stories/Stories-Michelles-Client-Custody-2x.png" alt="A treasure map detailing the path ahead with a blue X marking the spot is propped between a treasure chest and a safe in the pale sand." title="Michelle's client has questions about their bitcoin">
          </picture>
          <h3 class="small-card--title">Michelle's client needs help with custody.</h3>
          <p class="small-card--paragraph">Denise and Bill ask their Financial Advisor to store their bitcoin securely to avoid misplacing it a second time.</p>
        </a>

        <a href="/assets/pdfs/stories-from-the-street/Stories_Client-inherits-crypto_040323-1.pdf" class="ami-card small-card" target="_blank">
          <span class="sr-text">This link opens 'Paul's Client Inherits Crypto' PDF in a new tab</span>
          <picture>
            <source type="image/webp" srcset="/assets/imgs/street-stories/Stories-Pauls-Client-Inherits-Crypto-2x.webp">
            <source type="image/png" srcset="/assets/imgs/street-stories/Stories-Pauls-Client-Inherits-Crypto-2x.png">
            <img type="image/png" src="/assets/imgs/street-stories/Stories-Pauls-Client-Inherits-Crypto-2x.png" alt="A hand-drawn brown box sits open on on blue background, cryptocurrency symbols pouring upwards from it in a beam of soft yellow light." title="Paul's client needs direction to diversify">
          </picture>
          <h3 class="small-card--title">Paul's client inherits crypto.</h3>
          <p class="small-card--paragraph">Lisa and Liam inherited several Ledger Nanos holding digital asset and need a path to custody and diversification.</p>
        </a>

        <a href="/assets/pdfs/stories-from-the-street/Stories_Client-needs-NFT-taxation-help_040323-1.pdf" class="ami-card small-card" role="link" target="_blank">
          <span class="sr-text">This link opens 'Bo's Client Needs NFT help' PDF in a new tab</span>
          <picture>
            <source type="image/webp" srcset="/assets/imgs/street-stories/Stories-Bos-Client-NFT-taxation-2x.webp">
            <source type="image/png" srcset="/assets/imgs/street-stories/Stories-Bos-Client-NFT-taxation-2x.png">
            <img type="image/png" src="/assets/imgs/street-stories/Stories-Bos-Client-NFT-taxation-2x.png" alt="A hand-drawn collection of a curled tax form, a clipboard with an NFT cat wearing sunglasses and a yellow stack of cryptocurrency coins." title="Bo's client needs an NFT added to the portfolio">
          </picture>
          <h3 class="small-card--title">Bo's client needs NFT taxation help.</h3>
          <p class="small-card--paragraph">Bo is an RIA and his client's son has just purchased a rare NFT, to be addressed as part of the family portfolio.</p>
        </a>
      </div>
    </article>
  </section>

  <section class="da-reading-room" id="digital-assets-reading-room">
    <article class="section-intro--simple">
      <div class="btn-icon icon__ami-default">
        <picture>
          <source type="image/webp" srcset="/assets/imgs/icons/DA-Reading-Room_icon_Book.webp">
          <source type="image/png" srcset="/assets/imgs/icons/DA-Reading-Room_icon_Book.png">
          <img type="image/png" src="/assets/imgs/icons/DA-Reading-Room_icon_Book.png" width="27" alt="" title="Learn more about blockchain topics" aria-hidden="true">
        </picture>        
      </div>
      <h2>Digital Assets Reading Room</h2>
      <p>Deeper dives into blockchain topics.</p>
    </article>

    <article class="card-container">
      <div class="two-cards">

        <a href="https://www.coinbase.com/en-ca/blog/rising-allocations-broadening-use-cases-new-research-from-EY-parthenon-and-Coinbase" target="_blank" class="ami-card horizontal-card">

          <picture class="horizontal-card--image">
            <source type="image/webp" srcset="/assets/imgs/reading-room-books/coinbase-IIS.webp">
            <source type="image/jpg" srcset="/assets/imgs/reading-room-books/coinbase-IIS.jpg">
            <img type="image/jpg" src="/assets/imgs/reading-room-books/coinbase-IS.jpg" width="153" alt="A bright blue cover with white titling reading 'Institutional Investor Survey'" title="Institutional Investor Survey: EY-Parthenon and Coinbase—March 2025">
          </picture>
          <h3 class="horizontal-card--title">Institutional Investor Survey: EY-Parthenon and Coinbase—March 2025</h3> 
          <p class="horizontal-card--paragraph faux-link"><strong>Source: </strong>
            <span>Institutional Investor Survey - Coinbase</span>
          </p>
          <p class="horizontal-card--paragraph">
            New research from EY-Parthenon and Coinbase finds that 83% of institutional investors plan to increase their exposure to crypto this year.
          </p>
        </a>

        <a href="https://www.harpercollins.ca/9780063299955/web3/" target="_blank" class="ami-card horizontal-card">
          <picture class="horizontal-card--image">
            <source type="image/webp" srcset="/assets/imgs/reading-room-books/web3.webp">
            <source type="image/jpg" srcset="/assets/imgs/reading-room-books/web3.jpg">
            <img type="image/jpeg" src="/assets/imgs/reading-room-books/web3.jpg" width="153" alt="A black cover featuring the title, Web3, in bright paint-like strokes in yellow, pink, blue, red and purple.  Written by Alex Tapscott" title="Web3 by Alex Tapscott">
          </picture>
          <h3 class="horizontal-card--title">Web3 by Alex Tapscott</h3>
          <p class="horizontal-card--paragraph faux-link"><strong>Source: </strong>
            <span>Find "Web3" online</span>
          </p>
          <p class="horizontal-card--paragraph">
            An essential introduction and guide to navigating the next Internet revolution, this book breaks down the next generation of the Internet.
          </p>
        </a>

        <a href="https://reports.stm.co/" target="_blank" class="ami-card horizontal-card">
          <picture class="horizontal-card--image">
            <source type="image/webp" srcset="/assets/imgs/reading-room-books/STM-report.webp">
            <source type="image/jpg" srcset="/assets/imgs/reading-room-books/STM-report.jpg">
            <img type="image/jpg" src="/assets/imgs/reading-room-books/STM-report.jpg" width="153" alt="A white cover with spring green coloured geometric shapes in the corners, the title and text of the report in bold." title="Security Token Market (STM) Report: State of Tokenization by 2030">
          </picture>
          <h3 class="horizontal-card--title">Security Token Market (STM) Report: State of Tokenization by 2030</h3>
          <p class="horizontal-card--paragraph faux-link"><strong>Source: </strong>
            <span>Find the Security Token Market (STM) Report online</span>
          </p>
          <p class="horizontal-card--paragraph">
            A special report assessing the potential growth of the tokenization industry.
        </a>

        <a href="https://go.chainalysis.com/2023-crypto-crime-report.html" target="_blank" class="ami-card horizontal-card">
          <picture class="horizontal-card--image">
            <source type="image/webp" srcset="/assets/imgs/reading-room-books/2023-crypto-crime-report.webp">
            <source type="image/jpeg" srcset="/assets/imgs/reading-room-books/2023-crypto-crime-report.jpeg">
            <img type="image/jpeg" src="/assets/imgs/reading-room-books/2023-crypto-crime-report.jpeg" width="153" alt="A white cover with the title in bright blue. A face seen in profile is digitalized with fragmented blocks of orange, mint green and white to obscure their identity." title="The Chainalisys 2023 Crypto Crime Report">
          </picture>
          <h3 class="horizontal-card--title">The Chainalysis 2023 Crypto Crime Report</h3>
          <p class="horizontal-card--paragraph faux-link"><strong>Source: </strong>
            <span>Find "The Chainalysis 2023 Crypto Crime Report" online</span>
          </p>
          <p class="horizontal-card--paragraph">
            Chainalysis breaks down crypto crime data, trends and more in their 2023 Crypto Crime Report.
          </p>
        </a>
      </div>
    </article>
  </section>

  <section class="bookmarks-news-bites">
    <div class="simple-banner"></div>
    <article class="ami-card large-card">
      <picture>
        <source type="image/webp" srcset="/assets/imgs/accents/AmiLearn-icon_Bookmark.webp">
        <source type="image/png" srcset="/assets/imgs/accents/AmiLearn-icon_Bookmark.png">
        <img type="image/png" src="/assets/imgs/accents/AmiLearn-icon_Bookmark.png" width="60" alt="" title="The Essential Digital Asset Bookmark List for Wealth Managers" aria-hidden="true">
      </picture>
      <h4 class="large-card--title">The Essential Digital Asset Bookmark List for Wealth Managers</h4>

      <ol class="popout-booklist">
        <li>
          <a href="https://www.coindesk.com/" target="_blank">Coindesk</a>
        </li>
        <li>
          <a href="https://www.blockchainresearchinstitute.org/" target="_blank">Blockchain Research Institute</a>
        </li>
        <li>
          <a href="https://weissratings.com/en/crypto" target="_blank">Weiss Crypto Ratings</a>
        </li>
        <li>
          <a href="https://coinmarketcap.com/" target="_blank">CoinMarketCap</a>
        </li>
        <li>
          <a href="https://decrypt.co" target="_blank">Decrypt</a>
        </li>
        <li>
          <a href="https://www.digitalassetresearch.com/" target="_blank">Digital Asset Research</a>
        </li>
        <li>
          <a href="https://milkroad.com/" target="_blank">MilkRoad</a>
        </li>
        <li>
          <a href="https://blockworks.co" target="_blank">Blockworks</a>
        </li>
        <li>
          <a href="https://www.reuters.com/business/future-of-money/" target="_blank">Reuters - Future of Money</a>
        </li>
        <li>
          <a href="https://finance.yahoo.com/crypto/" target="_blank">yahoo! Finance - Crypto</a>
        </li>
      </ol>
    </article>

    <article class="inset-bookmarks">
      <h4 class="large-card--title">News Bites</h4>
      <ul>
        <li class="newsbite-icon">
          <a href="https://www.coindesk.com/coindesk-indices/2025/03/26/crypto-for-advisors-what-is-a-bitcoin-strategic-reserve" target="_blank">
            Crypto for Advisors: What is a Bitcoin Strategic Reserve?
          </a>
        </li>
        <li class="newsbite-icon">
          <a href="https://www.forbes.com/sites/beccabratcher/2025/03/08/occs-new-guidance-marks-shift-in-us-crypto-banking-regulations/" target="_blank">
            OCC greenlights crypto custody for banks
          </a>
        </li>
        <li class="newsbite-icon">
          <a href="https://www.ccn.com/news/crypto/us-states-strategic-bitcoin-reserve-2025/" target="_blank">
            At least 16 U.S. states have proposed or passed legistlation for a Bitcoin Strategic Reserve
          </a>
        </li>
        <li class="newsbite-icon">
          <a href="https://www.blackrock.com/corporate/investor-relations/larry-fink-annual-chairmans-letter?s=09" target="_blank">
            In BlackRock's 2025 Annual Chairman's Letter to Investors, Larry Fink posed:<em> 'Can bitcoin eat away at the U.S. dollar's reserve status?'</em>
          </a>
        </li>
        <li class="newsbite-icon">
          <a href="https://www.sec.gov/newsroom/speeches-statements/statement-stablecoins-040425" target="_blank">
            SEC clarifies that most stablecoins are not securities, when used for payment
          </a>
        </li>
      </ul>
    </article>
  </section>
  <app-learn-more />
</main>
